import React from "react";
import { AppInfo } from "./AppInfo";
import { useEffect } from "react";

function jumpAppStore() {
  window.location.href = "https://apps.apple.com/cn/app/heytap%E6%99%BA%E8%83%BD%E5%AE%B6%E5%B1%85/id1516237572";
}

export const IOSPage = () => {

  useEffect(() => {
    jumpAppStore();
  }, [])

  return (
    <div className="ios-download-page">
      <AppInfo />
      <div className="footer">
        <p className="remarks">
          “智能家居”，“heytap智能家居”和“欢太智能家居”为同一APP在不同平台的名称，请放心下载。
        </p>
        <div className="btn-download" onClick={jumpAppStore}>立即下载</div>
      </div>
    </div>
  );
}
